// extracted by mini-css-extract-plugin
module.exports = {"topic":"rigcard_topic__2Hub9","btn":"rigcard_btn__3ZF4r","rigspecs":"rigcard_rigspecs__2lqa8","rig":"rigcard_rig__1w4kd"};